import {
  ResponseRanking,
  ResponseInitRankingProvincias,
  ResponseRankingProvincias,
  ResponseLocalidadRanking,
  ResponseCalificacionesHistoricas,
  ResponseRankingEquipoGanador,
  ResponseRankingsInit,
} from '@/types/ranking';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt, { axiosGdtWithoutCredentials } from '@/utils/axiosGdt';

export const getRanking = axiosErrorHandler(
  async (type: 'f5' | 'f11' | 'f5Fecha' | 'f11Fecha', ID: string) => {
    const types = {
      f5: URLs.RANKING_GENERAL_F5,
      f11: URLs.RANKING_GENERAL_F11,
      f5Fecha: URLs.RANKING_FECHA_F5,
      f11Fecha: URLs.RANKING_FECHA_F11,
    };
    const response = await axiosGdtWithoutCredentials.get<ResponseRanking>(
      `${types[type]}${ID}.json?q=${new Date().getTime()}`
    );

    return response.data;
  },
  TEXTS.defaultError,
  // TODO: sacar esto cuando el backend exponga un flag de "ranking exportado"
  // para esta fecha y podamos evitar el pedido en vez de solo silenciar el 404.
  { silentStatusCodes: [404] }
);

export const initRankings = axiosErrorHandler(async () => {
  const response = await axiosGdt.get<ResponseRankingsInit>(
    `${URLs.RANKING_INIT}`
  );
  return response.data;
}, TEXTS.defaultError);

export const initProvinciaRanking = axiosErrorHandler(async () => {
  const response = await axiosGdt.get<ResponseInitRankingProvincias>(
    `${URLs.RANKING_INIT_PROVINCIA}`
  );

  return response.data;
}, TEXTS.defaultError);

export const getRankingPronvicias = axiosErrorHandler(
  async (id: string, isFecha: boolean) => {
    const response = await axiosGdt.get<ResponseRankingProvincias>(
      `${URLs.RANKING_PROVINCIAS}&idProvincia=${id}&isFecha=${isFecha}`
    );

    return response.data;
  },
  TEXTS.defaultError
);

export const getRankingLocalidad = axiosErrorHandler(
  async (noCountry = true) => {
    const response = await axiosGdt.get<ResponseLocalidadRanking>(
      `${URLs.RANKING_LOCALIDAD}${noCountry ? '&noConsiderarPaises=1' : ''}`
    );

    return response.data;
  },
  TEXTS.defaultError
);

export const getCalificacionesHistoricas = axiosErrorHandler(
  async (idUsuario: number, tipoCompetencia = 1) => {
    const response = await axiosGdt.get<ResponseCalificacionesHistoricas>(
      `${URLs.RANKING_CALIFICACIONES_HISTORICAS}?idUsuario1=${idUsuario}&tipoCompetencia=${tipoCompetencia}`
    );

    return response.data;
  },
  TEXTS.defaultError
);
/* para probar la función desde la consola del navegador
declare global {
  interface Window {
    getCalificacionesHistoricas?: typeof getCalificacionesHistoricas;
  }
}
window.getCalificacionesHistoricas = getCalificacionesHistoricas;
*/

export const getEquipoGanador = axiosErrorHandler(
  async (idFecha: string, isF5: boolean, isDate: boolean) => {
    let url = URLs.RANKING_EQUIPO_GANADOR_GENERAL;
    if (isDate) {
      url = URLs.RANKING_EQUIPO_GANADOR;
    }

    if (isF5) {
      url = URLs.RANKING_EQUIPO_GANADOR_F5_GENERAL;
      if (isDate) {
        url = URLs.RANKING_EQUIPO_GANADOR_F5_FECHA;
      }
    }

    const response = await axiosGdtWithoutCredentials.get<
      ResponseRankingEquipoGanador[]
    >(`${url}${idFecha}.json?q=${new Date().getTime()}`);

    return response.data;
  },
  TEXTS.defaultError
);
